<template>
  <div style="height:670px;padding:5px;">
    <div style="font-size:7px">
      Average Slot Age: {{stats.averageSlotAge.toFixed(2)}}min
    </div>
    <div>
      <div style="font-weight:bold;font-size:18px;" >Daily Activity</div>
      <line-chart :data="getDailyChartData()" style="height:300px;"></line-chart>
    </div>
    <div>
      <div style="font-weight:bold;font-size:18px;">Daily Activity Deltas</div>
      <line-chart :data="getDailyDeltaChartData()" style="height:300px;"></line-chart>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      stats: {
        deliveries: 5550,
        averageSlotAge: 5550,
      },
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    computeDeltas(data) {
      const result = {};
      const keys = Object.keys(data);
      const values = Object.values(data);
      for (let i = 0; i < keys.length - 1; i++) {
        result[keys[i]] = values[i] - values[i + 1];
      }
      return result;
    },

    getData() {
      const options = {
        method: 'get',
        url: '/read/updatescheduler_statistics_oasis/v1',
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;

          console.log('-------------------------------------------');
          console.log(JSON.stringify(res.data));

          this.stats.deliveries = res.data.autoStaged - res.data.autoUnstaged - res.data.autoUnstagedDueToHungCount;
          this.stats.autoStaged = res.data.autoStaged;
          this.stats.autoUnstaged = res.data.autoUnstaged;
          this.stats.autoUnstagedDueToHungCount = res.data.autoUnstagedDueToHungCount;
          this.stats.averageSlotAge = res.data.averageSlotAge;

          this.stats.dailyDeliveries = res.data.dailyStatistics.deliveries;
          this.stats.dailyAlignersAtCurrentVersion = res.data.dailyStatistics.alignersAtCurrentVersion;
          this.stats.dailyAutoStaged = res.data.dailyStatistics.autoStaged;
          this.stats.dailyConnectedCount = res.data.dailyStatistics.connectedCount;

          this.stats.dailyDeliveriesDeltas = this.computeDeltas(this.stats.dailyDeliveries);
          this.stats.dailyAlignersAtCurrentVersionDeltas = this.computeDeltas(this.stats.dailyAlignersAtCurrentVersion);

          console.log('stats: ', this.stats);
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    getDailyChartData() {
      const result = [];

      result.push({ name: 'Deliveries Attempted', data: this.stats.dailyDeliveries });
      result.push({ name: 'Oasis Aligners with Current Software', data: this.stats.dailyAlignersAtCurrentVersion });

      return result;
    },

    getDailyDeltaChartData() {
      const result = [];

      result.push({ name: 'Deliveries Attempted', data: this.stats.dailyDeliveriesDeltas });
      result.push({ name: 'Oasis Aligners with Current Software', data: this.stats.dailyAlignersAtCurrentVersionDeltas });

      return result;
    },
  },
};
</script>
